import CardHeaderRightText from './card-header-right-text';

export default CardHeaderRightText;
